import { getRouteApi, useNavigate } from "@tanstack/react-router";

import { CurrentPlanCard } from "./components/CurrentPlanCard";
import { OverviewSkeleton } from "./components/OverviewSkeleton";
import { PaymentMethodsCard } from "./components/PaymentMethodsCard";
import { RecentInvoicesSection } from "./components/RecentInvoicesSection";
import { UpcomingPaymentCard } from "./components/UpcomingPaymentCard";
import { useSubscriptionOverview } from "./hooks/useSubscriptionOverview";

const billingRoute = getRouteApi("/_auth/_app-shell/billing/$projectId");

export function OverviewTab() {
  const { projectId } = billingRoute.useParams();
  const { data, isError, isPending, refetch } = useSubscriptionOverview(
    Number(projectId),
  );
  const navigate = useNavigate();

  if (isPending) {
    return <OverviewSkeleton />;
  }

  if (isError) {
    return (
      <div className="p-xl">
        <p className="text-sm text-text-secondary">
          Failed to load subscription overview.
        </p>
        <button
          className="mt-md text-sm text-button-primary-bg hover:underline"
          onClick={() => refetch()}
          type="button"
        >
          Retry
        </button>
      </div>
    );
  }

  if (!data) return null;

  return (
    <div className="p-xl flex flex-col gap-xl sm:gap-3xl">
      <div className="grid grid-cols-1 gap-md md:gap-xl lg:grid-cols-3">
        <CurrentPlanCard data={data} />

        <PaymentMethodsCard
          data={data}
          onNavigate={() =>
            navigate({
              params: { projectId },
              to: "/billing/$projectId/payment-methods",
            })
          }
        />

        <UpcomingPaymentCard data={data} />
      </div>

      <RecentInvoicesSection
        onSeeAll={() =>
          navigate({
            params: { projectId },
            to: "/billing/$projectId/invoices",
          })
        }
      />
    </div>
  );
}
